import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import isTrustworthy from '../helpers/isTrustworthy';
import { eventHandler, F2BCore, Login } from '../lib/login';
import { useSession } from '../lib/hooks';
import { getEnv } from '../environment/resolve';

// Served per environment by CloudFront from that env's bucket, not from this
// build: see the Login Module section of CLAUDE.md.
const src = '/login_module/index.html';
const redirectToOauth = service => {
  if (!['apple', 'classlink', 'clever', 'google'].includes(service)) {
    console.warn(`unsupported external login serice: ${service}`);
    return;
  }
  window.location = `${getEnv().appHost}/${service}`;
};
const redirectTo = urlString => {
  const appHost = getEnv().appHost;
  const url = new URL(urlString, appHost);
  window.location = url.href.replace(url.origin, appHost);
};
const LoginPage = () => {
  const iframeRef = useRef();
  const {
    user,
    refresh
  } = useSession();
  const {
    login_method,
    return_url
  } = useRouter().query;
  useEffect(() => {
    window.F2BCore = F2BCore;
    window.Login = Login;
    const handler = ({
      data,
      origin,
      source
    }) => {
      if (window.origin !== origin) {
        return;
      }
      if (iframeRef.current?.contentWindow !== source) {
        return;
      }
      switch (data.event) {
        case 'SUCCESS_LOGIN':
          return refresh();
        case 'EXTERNAL_LOGIN':
          return redirectToOauth(data.page);
        case 'OPEN_PAGE':
          return redirectTo(data.page);
        default:
          return eventHandler(data, {
            source,
            origin
          });
      }
    };
    window.addEventListener('message', handler);
    if (iframeRef.current) {
      iframeRef.current.src = `${src}?method=${login_method}`;
    }
    return () => {
      window.removeEventListener('message', handler);
      delete window.F2BCore;
      delete window.Login;
    };
  }, [iframeRef, login_method, refresh]);
  useEffect(() => {
    if (user) {
      window.location = isTrustworthy(return_url) ? return_url : getEnv().appHost;
    }
  }, [user, return_url]);
  return user ? null : <iframe ref={iframeRef} allow="microphone; autoplay" style={{
    position: 'absolute',
    width: '100%',
    height: '100%',
    border: 0
  }} />;
};
LoginPage.subLayout = 'nonauthed';
export default LoginPage;